import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { GoogleAnalyticsService } from "@/core/services";
import {
  AuthenticationService,
  ConfigurationService,
  AlertService,
} from "@/shared-module/services";
import { environment } from "environments/environment";

@Component({ templateUrl: "login.component.html" })
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  errorMessage: string;
  needRedirect = true;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private googleService: GoogleAnalyticsService,
    private configurationService: ConfigurationService,
  ) {
    this.needRedirect = environment.redirectLoginPage;
    if (this.needRedirect) {
      window.location.href = environment.redirectLoginUrl;
    }

    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });

    // get return url from route parameters or default to '/login'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || "/login";
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    const thisObject = this;

    this.authenticationService
      .login(this.f.username.value, this.f.password.value)
      .subscribe(
        (data: any) => {
          thisObject.loading = false;
          if (data.isSuccess) {
            this.googleService.record(
              "connection",
              "login",
              "username " + this.f.username.value,
            );
            if (data.displayDemoPopup) {
              this.configurationService.setDemoPopup(true);
            }
            thisObject.router.navigate([data.firstPageUrl]);
          } else {
            this.googleService.record(
              "connection",
              "login failed",
              "username " + this.f.username.value,
            );
            thisObject.errorMessage = data.errorMessage;
          }
        },
        (error) => {
          thisObject.alertService.error(error);
          thisObject.loading = false;
        },
      );
  }
}
